import { ModelSnippetFn } from '../types';

export const text: ModelSnippetFn = (props) => `
////////////////////////////////////////////////////////////////////////////////////////////////////
// In this section, we set the user authentication, user and app ID, model details, and the URL
// of the text we want as an input. Change these strings to run your own example.
///////////////////////////////////////////////////////////////////////////////////////////////////

// Your PAT (Personal Access Token) can be found in the Account's Security section
const PAT = '${props.pat}';
// Specify the correct user_id/app_id pairings
// Since you're making inferences outside your app's scope
const USER_ID = '${props.userId}';    
const APP_ID = '${props.appId}';
// Change these to whatever model and text URL you want to use
const MODEL_ID = '${props.modelId}';
const MODEL_VERSION_ID = '${props.modelVersionId}';    
const RAW_TEXT = 'I love your product very much';
// To use a hosted text file, assign the url variable
// const TEXT_FILE_URL = '${props.inputUrl}';
// Or, to use a local text file, assign the url variable
// const TEXT_FILE_BYTES = 'YOUR_TEXT_FILE_BYTES_HERE';

///////////////////////////////////////////////////////////////////////////////////
// YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
///////////////////////////////////////////////////////////////////////////////////

const raw = JSON.stringify({
    "user_app_id": {
        "user_id": USER_ID,
        "app_id": APP_ID
    },
    "inputs": [
        {
            "data": {
                "text": {
                    "raw": RAW_TEXT
                    // url: TEXT_URL, allow_duplicate_url: true 
                    // raw: fileBytes
                }
            }
        }
    ]
});

const requestOptions = {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Authorization': 'Key ' + PAT
    },
    body: raw
};

// NOTE: MODEL_VERSION_ID is optional, you can also call prediction with the MODEL_ID only
// ${props.apiHost}/v2/models/{YOUR_MODEL_ID}/outputs
// this will default to the latest version_id

fetch("${props.apiHost}/v2/models/" + MODEL_ID + "/versions/" + MODEL_VERSION_ID + "/outputs", requestOptions)
    .then(response => response.text())
    .then(result => console.log(result))
    .catch(error => console.log('error', error));
`;

export const image: ModelSnippetFn = (props) => `
///////////////////////////////////////////////////////////////////////////////////////////////////
// In this section, we set the user authentication, user and app ID, model details, and the URL
// of the image we want as an input. Change these strings to run your own example.
//////////////////////////////////////////////////////////////////////////////////////////////////

// Your PAT (Personal Access Token) can be found in the Account's Security section
const PAT = '${props.pat}';
// Specify the correct user_id/app_id pairings
// Since you're making inferences outside your app's scope
const USER_ID = '${props.userId}';       
const APP_ID = '${props.appId}';
// Change these to whatever model and image URL you want to use
const MODEL_ID = '${props.modelId}';
const MODEL_VERSION_ID = '${props.modelVersionId}';    
const IMAGE_URL = '${props.inputUrl}';

///////////////////////////////////////////////////////////////////////////////////
// YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
///////////////////////////////////////////////////////////////////////////////////

const raw = JSON.stringify({
    "user_app_id": {
        "user_id": USER_ID,
        "app_id": APP_ID
    },
    "inputs": [
        {
            "data": {
                "image": {
                    "url": IMAGE_URL
                }
            }
        }
    ]
});

const requestOptions = {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Authorization': 'Key ' + PAT
    },
    body: raw
};

// NOTE: MODEL_VERSION_ID is optional, you can also call prediction with the MODEL_ID only
// ${props.apiHost}/v2/models/{YOUR_MODEL_ID}/outputs
// this will default to the latest version_id

fetch("${props.apiHost}/v2/models/" + MODEL_ID + "/versions/" + MODEL_VERSION_ID + "/outputs", requestOptions)
    .then(response => response.text())
    .then(result => console.log(result))
    .catch(error => console.log('error', error));
`;

export const audio: ModelSnippetFn = (props) => `
///////////////////////////////////////////////////////////////////////////////////////////////////
// In this section, we set the user authentication, user and app ID, model details, and the URL
// of the audio we want as an input. Change these strings to run your own example.
//////////////////////////////////////////////////////////////////////////////////////////////////

// Your PAT (Personal Access Token) can be found in the Account's Security section
const PAT = '${props.pat}';
// Specify the correct user_id/app_id pairings
// Since you're making inferences outside your app's scope
const USER_ID = '${props.userId}';       
const APP_ID = '${props.appId}';
// Change these to whatever model and audio URL you want to use
const MODEL_ID = '${props.modelId}';
const MODEL_VERSION_ID = '${props.modelVersionId}';    
const AUDIO_URL = '${props.inputUrl}';

///////////////////////////////////////////////////////////////////////////////////
// YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
///////////////////////////////////////////////////////////////////////////////////

const raw = JSON.stringify({
    "user_app_id": {
        "user_id": USER_ID,
        "app_id": APP_ID
    },
    "inputs": [
        {
            "data": {
                "audio": {
                    "url": AUDIO_URL
                }
            }
        }
    ]
});

const requestOptions = {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Authorization': 'Key ' + PAT
    },
    body: raw
};

// NOTE: MODEL_VERSION_ID is optional, you can also call prediction with the MODEL_ID only
// ${props.apiHost}/v2/models/{YOUR_MODEL_ID}/outputs
// this will default to the latest version_id

fetch("${props.apiHost}/v2/models/" + MODEL_ID + "/versions/" + MODEL_VERSION_ID + "/outputs", requestOptions)
    .then(response => response.text())
    .then(result => console.log(result))
    .catch(error => console.log('error', error));
`;

export const video: ModelSnippetFn = (props) => `
////////////////////////////////////////////////////////////////////////////////////////////////////////
// In this section, we set the user authentication, user and app ID, model details, URL of the video
// we want as an input, and sample_ms. Change these strings to run your own example.
///////////////////////////////////////////////////////////////////////////////////////////////////////

// Your PAT (Personal Access Token) can be found in the Account's Security section
const PAT = '${props.pat}';
// Specify the correct user_id/app_id pairings
// Since you're making inferences outside your app's scope
const USER_ID = '${props.userId}';    
const APP_ID = '${props.appId}';
// Change these to whatever model and video URL you want to use
const MODEL_ID = '${props.modelId}';
const MODEL_VERSION_ID = '${props.modelVersionId}';
const VIDEO_URL = '${props.inputUrl}';
// Change this to configure the FPS rate (If it's not configured, it defaults to 1 FPS) 
const SAMPLE_MS = 500;

///////////////////////////////////////////////////////////////////////////////////
// YOU DO NOT NEED TO CHANGE ANYTHING BELOW THIS LINE TO RUN THIS EXAMPLE
///////////////////////////////////////////////////////////////////////////////////

const raw = JSON.stringify({
    "user_app_id": {
        "user_id": USER_ID,
        "app_id": APP_ID
    },
    "inputs": [
        {
            "data": {
                "video": {
                    "url": VIDEO_URL
                }
            }
        }
    ],
    "model": {
        "output_info": {
            "output_config": {
                "sample_ms": SAMPLE_MS
            }

        }
    }
});

const requestOptions = {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Authorization': 'Key ' + PAT
    },
    body: raw
};

// NOTE: MODEL_VERSION_ID is optional, you can also call prediction with the MODEL_ID only
// ${props.apiHost}/v2/models/{YOUR_MODEL_ID}/outputs
// this will default to the latest version_id

fetch("${props.apiHost}/v2/models/" + MODEL_ID + "/versions/" + MODEL_VERSION_ID + "/outputs", requestOptions)
    .then(response => response.text())
    .then(result => console.log(result))
    .catch(error => console.log('error', error));
`;
